// extracted by mini-css-extract-plugin
module.exports = {"footer-container":"desktopFooter_footer-container__1X0SO","footer-border":"desktopFooter_footer-border__CxFF5","hidden":"desktopFooter_hidden__1Yios"};